<mat-toolbar class="topbar horizontal-topbar gap-1">
  <div class="container px-0! lg:px-6!">
    <div class="hidden md:flex">
      <app-branding></app-branding>
    </div>

    <!-- Mobile Menu -->
    <button mat-icon-button data-overlay-nav-toggle (click)="toggleMobileNav.emit()" class="flex items-center justify-center lg:hidden! mx-1">
      <i class="iconify text-xl! flex" data-icon="solar:hamburger-menu-line-duotone"></i>
    </button>
    <!-- --------------------------------------------------------------- -->

    <span class="flex-1"></span>

    <!-- Mobile Menu -->
    <button mat-icon-button (click)="toggleMobileFilterNav.emit()" class="flex lg:hidden! justify-center mx-1">
      <i class="iconify text-xl! flex" data-icon="solar:menu-dots-outline"></i>
    </button>

    <!-- --------------------------------------------------------------- -->
    <!-- Notification Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button mat-icon-button [matMenuTriggerFor]="notificationmenu" aria-label="Notifications"
      [matBadge]="notificationsUnreadCount() > 0 ? notificationsUnreadCount() : null" matBadgeColor="warn"
      matBadgeSize="small" class="hidden lg:flex items-center justify-center">
      <i class="iconify text-xl! flex" data-icon="solar:bell-line-duotone"></i>
    </button>
    <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow" (opened)="onNotificationsMenuOpened()">
      <div class="flex items-center justify-between px-7.5 py-4">
      <h6 class="text-base font-semibold">{{ 'header.notifications.title' | translate }}</h6>
      @if (orderNotificationItems().length > 0) {
      <span class="bg-primary text-[var(--mat-sys-on-primary)] px-2 py-1 font-medium rounded text-xs">
        {{ 'header.notifications.newCount' | translate:{ count: orderNotificationItems().length } }}
      </span>
      }
      </div>

    @for(notification of orderNotificationItems(); track notification.id) {
      <button mat-menu-item class="px-7.5! py-3!">
        <div class="flex gap-4 items-center">
          <span
            class="shrink-0 text-primary bg-light-primary rounded-full size-12! flex items-center justify-center">
            <i-tabler name="receipt" class="text-xl! flex"></i-tabler>
          </span>
          <div class="w-full">
            <div class="flex items-center justify-between w-full">
              <h5 class="text-sm font-semibold">
                {{ 'header.notifications.orderReceived.title' | translate:{ number: notification.number } }}
              </h5>
              <span class="block text-xs">{{ notification.time }}</span>
            </div>
            <span class="block text-truncate text-xs">{{ 'header.notifications.orderReceived.subtitle' | translate }}</span>
          </div>
        </div>
      </button>
      } @empty {
      <div class="px-7.5 py-6 text-center text-xs text-muted">
        {{ 'header.notifications.empty' | translate }}
      </div>
      }
    </mat-menu>

    <app-company-switcher />
    <app-location-switcher />

    <!-- --------------------------------------------------------------- -->
    <!-- profile Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button mat-button [matMenuTriggerFor]="profilemenu" aria-label="Profile" class="profile-btn px-2! hidden lg:flex">
      <div class="flex items-center gap-2">
        @if (authSession.user()) {
        <div
          class="rounded-full object-cover size-9! profile-dd shrink-0 bg-primary flex items-center justify-center text-[var(--mat-sys-on-primary)] text-xs font-semibold">
          {{ userInitialsDisplay() }}
        </div>
        @if (toolbarUserLabel(); as userLabel) {
        <span class="hidden xl:inline text-xs text-muted max-w-[180px] truncate">{{ userLabel }}</span>
        }
        } @else {
        <img src="/assets/images/profile/user-1.jpg" class="rounded-full object-cover size-9! profile-dd" width="36" alt="" />
        }

        <i data-icon="solar:alt-arrow-down-bold" class="iconify text-sm"></i>
      </div>
    </button>
    <mat-menu #profilemenu="matMenu" class="topbar-dd profile-menu-panel" xPosition="before">
      <div class="profile-menu-panel__identity">
        @if (authSession.user(); as sessionUser) {
        <div class="profile-menu-panel__avatar" aria-hidden="true">
          {{ userInitialsDisplay() }}
        </div>
        <div class="profile-menu-panel__meta">
          <h6 class="profile-menu-panel__name">
            <span class="truncate">{{ sessionUser.name }}</span>
            @if (sessionRoleBadge(); as role) {
            <span class="profile-menu-panel__role">{{ role }}</span>
            }
          </h6>
          <span class="profile-menu-panel__email">{{ sessionUser.email }}</span>
          @if (primaryCompanyDisplay(); as companyName) {
          <span class="profile-menu-panel__company">{{ companyName }}</span>
          }
        </div>
        } @else {
        <img
          src="/assets/images/profile/user-1.jpg"
          class="profile-menu-panel__avatar object-cover"
          width="44"
          height="44"
          alt=""
        />
        <div class="profile-menu-panel__meta">
          <h6 class="profile-menu-panel__name">—</h6>
          <span class="profile-menu-panel__email">—</span>
        </div>
        }
      </div>

      @if (showWorkspaceSwitcher()) {
        <button mat-menu-item type="button" (click)="openWorkspacePicker()">
          <i-tabler name="building-store" matMenuItemIcon class="profile-menu-panel__item-icon" aria-hidden="true"></i-tabler>
          <span class="profile-menu-panel__item-label">{{ 'header.profile.menu.switchBusiness' | translate }}</span>
        </button>
        <mat-divider></mat-divider>
      }
      @for (profile of profileMenuItems(); track profile.id) {
        @if (!profile.logout) {
        <button mat-menu-item [routerLink]="profile.link">
          <i-tabler [name]="profile.icon" matMenuItemIcon class="profile-menu-panel__item-icon" aria-hidden="true"></i-tabler>
          <span class="profile-menu-panel__item-label">{{ profile.titleKey | translate }}</span>
        </button>
        }
      }

      <mat-divider></mat-divider>

      @if (showAppVersion()) {
        <div class="profile-menu-panel__version" title="Versión de la aplicación">
          v{{ appVersionLabel }}
        </div>
      }

      <button mat-menu-item class="profile-menu-panel__sign-out" (click)="signOut()">
        <i-tabler name="logout" matMenuItemIcon class="profile-menu-panel__item-icon" aria-hidden="true"></i-tabler>
        <span class="profile-menu-panel__item-label">{{ 'header.profile.menu.signOut' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
